import type { RouteRecordRaw } from 'vue-router'
const routers: RouteRecordRaw = {
  path: '/shp-prod-comment',
  name:'ShpProdComment',
  meta: {
    title: '商品评价管理'
  },
  children: [
    {
      path: 'list',
      name: 'ShpProdCommentList',
      meta: {
        title: '商品评价列表'
      },
      component: ()=>{return import("@/views/shp-prod-comment/ShpProdCommentList.vue")}
    },
    {
      path: 'add',
      name: 'ShpProdCommentAdd',
      meta: {
        title: '商品评价新增'
      },
      component: ()=>{return import("@/views/shp-prod-comment/ShpProdCommentAdd.vue")}
    },
    {
      path: 'edit',
      name: 'ShpProdCommentEdit',
      meta: {
        title: '商品评价编辑'
      },
      component: ()=>{return import("@/views/shp-prod-comment/ShpProdCommentEdit.vue")}
    }
  ]
}
export default routers
